import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Banks\CreateBankController::__invoke
* @see app/Http/Controllers/Banks/CreateBankController.php
* @route '/api/bank'
*/
const CreateBankController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateBankController.url(options),
    method: 'post',
})

CreateBankController.definition = {
    methods: ["post"],
    url: '/api/bank',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Banks\CreateBankController::__invoke
* @see app/Http/Controllers/Banks/CreateBankController.php
* @route '/api/bank'
*/
CreateBankController.url = (options?: RouteQueryOptions) => {
    return CreateBankController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\CreateBankController::__invoke
* @see app/Http/Controllers/Banks/CreateBankController.php
* @route '/api/bank'
*/
CreateBankController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateBankController.url(options),
    method: 'post',
})

export default CreateBankController